"use client";

import Icon from "../atoms/icon";
import Link from "../atoms/link";

/**
 * @name SocialLinks
 * @description Renders a list of social media links with icons.
 *
 * @returns {JSX.Element} The rendered social links component.
 */
const SocialLinks = () => (
  <ul className="flex gap-2 xxxl:gap-3">
    <li>
      <Link
        href="#"
        aria-label="social link"
        className="p-1 md:p-1.5 xxxl:p-2 hover:bg-primary hover:text-n0 duration-300 inline-flex text-primary rounded-full border border-primary"
      >
        <Icon name="fa-brands fa-whatsapp" />
      </Link>
    </li>
    <li>
      <Link
        href="#"
        aria-label="social link"
        className="p-1 md:p-1.5 xxxl:p-2 hover:bg-primary hover:text-n0 duration-300 inline-flex text-primary rounded-full border border-primary"
      >
        <Icon name="fa-brands fa-twitter" />
      </Link>
    </li>
    <li>
      <Link
        href="#"
        aria-label="social link"
        className="p-1 md:p-1.5 xxxl:p-2 hover:bg-primary hover:text-n0 duration-300 inline-flex text-primary rounded-full border border-primary"
      >
        <Icon name="fa-brands fa-facebook" />
      </Link>
    </li>
    <li>
      <Link
        href="#"
        aria-label="social link"
        className="p-1 md:p-1.5 xxxl:p-2 hover:bg-primary hover:text-n0 duration-300 inline-flex text-primary rounded-full border border-primary"
      >
        <Icon name="fa-brands fa-instagram" />
      </Link>
    </li>
    <li>
      <Link
        href="#"
        aria-label="social link"
        className="p-1 md:p-1.5 xxxl:p-2 hover:bg-primary hover:text-n0 duration-300 inline-flex text-primary rounded-full border border-primary"
      >
        <Icon name="fa-brands fa-linkedin" />
      </Link>
    </li>
  </ul>
);

export default SocialLinks;
